export default "<h2 class=\"mb-2\">Site</h2>\n"